import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const productLinks = [
    { label: 'Explore debates', path: '/explore' },
    { label: 'Arena', path: '/arena' },
    { label: 'Pricing', path: '/pricing' },
    { label: 'How it works', path: '/how-it-works' },
  ];

  const companyLinks = [
    { label: 'About', path: '/about' },
    { label: 'Terms', path: '/terms' },
    { label: 'Privacy', path: '/privacy' },
  ];

  return (
    <footer className="blueprint-grid-dark mt-auto bg-charcoal text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          {/* Wordmark + thesis */}
          <div className="md:col-span-6">
            <Link to="/" className="inline-flex items-center gap-2.5">
              <span className="relative block h-5 w-5 overflow-hidden rounded-[5px] border border-white/20">
                <span className="absolute inset-0 bg-steel-blue [clip-path:polygon(0_0,100%_0,0_100%)]" />
                <span className="absolute inset-0 bg-vermilion [clip-path:polygon(100%_0,100%_100%,0_100%)]" />
              </span>
              <span className="font-serif text-2xl">Steelman</span>
            </Link>
            <p className="mt-5 max-w-sm font-serif text-2xl leading-snug text-white/85 sm:text-3xl">
              Argue the best version of <em>every</em> idea.
            </p>
          </div>

          {/* Link columns */}
          <div className="md:col-span-3">
            <p className="eyebrow !text-white/40">Product</p>
            <ul className="mt-4 space-y-2.5">
              {productLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/60 transition-colors duration-200 hover:text-white"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow !text-white/40">Company</p>
            <ul className="mt-4 space-y-2.5">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/60 transition-colors duration-200 hover:text-white"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://x.com/steelman_ai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/60 transition-colors duration-200 hover:text-white"
                >
                  X / Twitter
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="font-mono text-[11px] uppercase tracking-eyebrow text-white/35">
            © {new Date().getFullYear()} Steelman
          </p>
          <p className="font-mono text-[11px] uppercase tracking-eyebrow text-white/35">
            Research → Opening → Rebuttal → Closing
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
